import { MutationOptions, useMutation, useQueryClient } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";
import { KYCComplaince } from "../@types";

function useUpdateEmploymentInfo<T>(
  options?: MutationOptions<APIResponse<T>, APIError, KYCComplaince>
) {
  const queryClient = useQueryClient();
  const { isLoading, isError, mutate, error } = useMutation<
    APIResponse<T>,
    APIError,
    KYCComplaince
  >(
    async (variables: Record<any, any>) => {
      return post(
        API_URL + "/account/user/account/update-kyc-details",
        variables,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
    },
    {
      onSettled() {
        queryClient.invalidateQueries("kyc_complaince");
      },
      ...options,
    }
  );

  return {
    updateEmploymentInfo: mutate,
    isupdateEmploymentInfoError: isError,
    updateEmploymentInfoError: error,
    isUpdatingInfo: isLoading,
  };
}

export default useUpdateEmploymentInfo;
